import React, { FC } from "react";
import { TextField } from "@mui/material";

interface PostalCodeFieldProps {
    value?: string;
    onChange?: (value: string) => void;
    isEditing?: boolean; // 編集モードかどうか
    maxLength?: number; // 最大桁数
}

const PostalCodeField: FC<PostalCodeFieldProps> = ({
    value = "",
    onChange,
    isEditing = false,
    maxLength = 7,
}) => {
    // 編集用の郵便番号
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value.replace(/[^\d]/g, ""); // 数字以外を削除
        if (onChange) {
            onChange(inputValue.slice(0, maxLength)); // 最大文字数を制限
        }
    };

    // 表示用のフォーマット
    const formatPostalCode = (postalCode: string) => {
        if (postalCode.length <= 3) return postalCode; // `XXX`
        return `${postalCode.slice(0, 3)}-${postalCode.slice(3)}`; // `XXX-XXXX`
    };

    return isEditing ? (
        <TextField
            fullWidth
            value={value}
            onChange={handleChange}
            size="small"
            inputProps={{
                inputMode: "numeric",
                maxLength,
                pattern: "\\d*",
            }}
        />
    ) : (
        <span>{formatPostalCode(value)}</span>
    );
};

export default PostalCodeField;
